import { useFieldArray, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { generateUUID } from '@dealstack/frontend/shared/other/react/generateUUID.ts';
import {
	MANAGE_CUSTOM_DETAILS_DEFINITIONS_FORM_SHAPE,
	ManageCustomDetailDefinitionField,
	ManageCustomDetailsDefinitionsForm,
} from '@dealstack/frontend/admin/pages/Manage/common/ManageCustomDetailsDefinitionsModal/types.ts';
import { SetOptional } from 'type-fest';
import { PreFillableFormTemplateTypeEnum } from '@dealstack/shared/lib/generated';

export const useManageCustomDetailsDefinitionsModalController = (
	initialCustomDefinitions: SetOptional<ManageCustomDetailDefinitionField, 'entityType'>[]
) => {
	const manageCustomDetailsDefinitionsForm = useForm<ManageCustomDetailsDefinitionsForm>({
		mode: 'all',
		defaultValues: { customDefinitions: initialCustomDefinitions ?? [] },
		resolver: zodResolver(MANAGE_CUSTOM_DETAILS_DEFINITIONS_FORM_SHAPE),
	});

	useEffect(() => {
		manageCustomDetailsDefinitionsForm.reset({ customDefinitions: initialCustomDefinitions });
	}, [initialCustomDefinitions]);

	const { fields, append, remove } = useFieldArray<ManageCustomDetailsDefinitionsForm>({
		name: 'customDefinitions',
		control: manageCustomDetailsDefinitionsForm.control,
	});

	const onAddNewClicked = () => {
		append({
			name: '',
			instruction: '',
			localId: generateUUID(),
			entityType: PreFillableFormTemplateTypeEnum.INDIVIDUAL,
		});
	};

	const onRemoveClicked = (arrayIndex: number) => {
		remove(arrayIndex);
	};

	return {
		manageCustomDetailsDefinitionsForm,
		fields,
		onRemoveClicked,
		onAddNewClicked,
	};
};
